// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfse from './selecao_todos_nfse';
import { Input } from '../../../../../../common/input';

export default function CamposRps() {
  return (
    <FormSection name="rps">
      <SelecaoTodosNfse nomes={ ["rps"] } titulo="Dados do RPS"/>

      <div className="grupo-checkbox">
        <Input name="inscricaoPrestador" label="I.M. Prestador" checkbox/>
        <Input name="serieRps" label="Série" checkbox/>
        <Input name="numeroRps" label="Número" checkbox/>
        <Input name="tipoRps" label="Tipo" checkbox/>
        <Input name="dataEmissaoRps" label="Data Emissão" checkbox/>
        <Input name="statusRps" label="Status RPS" checkbox/>
        <Input name="tributacaoRps" label="Tributação" checkbox/>
      </div>
    </FormSection>
  );
}
